import React, { useState } from 'react';
import { FaClock, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import { MdSend } from 'react-icons/md';
import rajasthanTour from '../assets/tour1.webp';
import rajasthanTou from '../assets/tour2.webp';
import rajasthanTo from '../assets/tour3.webp';
import "../App.css"


const packages = [
  {
    title: '05 Days Jaipur & Udaipur Tour Package',
    duration: '4 Nights / 5 Days (Customizable)',
    locations: 'Jaipur, Ajmer, Pushkar & Udaipur',
    image: rajasthanTour,
    highlights: [
      'Air-conditioned accommodation on double & triple sharing basis',
      'Meal plan includes daily Breakfast & Dinner',
      '04 Nights Comfortable stays in well-rated 3-star hotels',
      'Private air-conditioned vehicle for all travel during the trip',
      'Licensed and government-approved tour guide for sightseeing',
      'Complimentary accommodation for children below 5 years of age',
    ],
  },
  {
    title: '05 Days Jodhpur & Jaisalmer Tour Package',
    duration: '4 Nights / 5 Days (Customizable)',
    locations: 'Jodhpur, Osian & Jaisalmer',
    image: rajasthanTou,
    highlights: [
      'Air-conditioned accommodation on double & triple sharing basis',
      'Meal plan includes daily Breakfast & Dinner',
      '04 Nights Comfortable stays in well-rated 3-star hotels',
      'Private air-conditioned vehicle for all travel during the trip',
      'All travel-related expenses covered – including driver allowance, fuel, parking, and taxes',
      'Licensed and government-approved tour guide for sightseeing',
      'Complimentary accommodation for children below 5 years of age'
    ],
  },
  {
    title: '06 Days Udaipur, Jodhpur & Jaisalmer Tour',
    duration: '5 Nights / 6 Days (Customizable)',
    locations: 'Udaipur, Jodhpur, Kheechan & Jaisalmer',
    image: rajasthanTo,
    highlights: [
      'Air-conditioned accommodation on double & triple sharing basis',
      'Meal plan includes daily Breakfast & Dinner',
      '04 Nights Comfortable stays in well-rated 3-star hotels',
      'Private air-conditioned vehicle for all travel during the trip',
      'All travel-related expenses covered – including driver allowance, fuel, parking, and taxes',
      'Licensed and government-approved tour guide for sightseeing',
      'Complimentary accommodation for children below 5 years of age',
    ],
    popular: true,
  },
  {
    title: '06 Days Jaipur, Jodhpur & Jaisalmer Tour Package',
    duration: '5 Nights / 6 Days (Customizable)',
    locations: 'Jaipur, Jodhpur, Kheechan & Jaisalmer',
    image: require('../assets/tour4.webp'),
    highlights: [
      'Air-conditioned accommodation on double & triple sharing basis',
      'Meal plan includes daily Breakfast & Dinner',
      '04 Nights Comfortable stays in well-rated 3-star hotels',
      'Private air-conditioned vehicle for all travel during the trip',
      'All travel-related expenses covered – including driver allowance, fuel, parking, and taxes',
      'Licensed and government-approved tour guide for sightseeing',
      'Complimentary accommodation for children below 5 years of age'
    ],
  },
  {
    title: '06 Days Jaipur, Ranthambhore & Udaipur Tour Package',
    duration: '5 Nights / 6 Days (Customizable)',
    locations: 'Jaipur, Ranthambhore, Chittorgarh & Udaipur',
    image: require('../assets/tour5.webp'),
    highlights: [
      'Air-conditioned accommodation on double & triple sharing basis',
      'Meal plan includes daily Breakfast & Dinner',
      '04 Nights Comfortable stays in well-rated 3-star hotels',
      'Private air-conditioned vehicle for all travel during the trip',
      'All travel-related expenses covered – including driver allowance, fuel, parking, and taxes',
      'Licensed and government-approved tour guide for sightseeing',
      'Complimentary accommodation for children below 5 years of age'
    ],
  },
  {
    title: '06 Days Delhi, Agra & Jaipur Tour Package',
    duration: '5 Nights / 6 Days (Customizable)',
    locations: 'Delhi, Agra & Jaipur',
    image: require('../assets/tour6.webp'),
    highlights: [
      'Air-conditioned accommodation on double & triple sharing basis',
      'Meal plan includes daily Breakfast & Dinner',
      ' 04 Nights Comfortable stays in well-rated 3-star hotels',
      'Private air-conditioned vehicle for all travel during the trip',
      'All travel-related expenses covered – including driver allowance, fuel, parking, and taxes',
      'Licensed and government-approved tour guide for sightseeing',
      'Complimentary accommodation for children below 5 years of age'
    ],
  }
];


const Packages = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    
    <section className='packages-section testclass'>
      <div className="text-center mb-16">
      {/* Tag with Icons */}
      <div className="inline-flex items-center gap-2 bg-pink-100/20 border border-pink-200 rounded-full px-6 py-2 mb-6">
        {/* Star Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-pink-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
        </svg>

        <span className="text-sm font-bold text-pink-600 tracking-widest uppercase">
          Featured Tours
        </span>

        {/* Award Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 text-pink-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
          <circle cx="12" cy="8" r="6" />
        </svg>
      </div>

      {/* Heading */}
      <h1 className="text-3xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-pink-600 to-rose-600 mb-4">
        Popular Rajasthan Tour Packages
      </h1>

      {/* Divider */}
      <div className="w-24 h-1 bg-gradient-to-r from-pink-600 to-rose-600 mx-auto mb-4 rounded-full"></div>

      {/* Description */}
      <p className="text-lg text-gray-600 max-w-2xl mx-auto">
        Discover the royal heritage and majestic beauty of Rajasthan with our
        carefully curated tour packages.
      </p>
    </div>
      <div className="packages-grid">
        {packages.map((pkg, index) => (
          <div className="package-card" key={index}>
        <img src={pkg.image} alt={pkg.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />

            <div style={styles.content}>
              {pkg.popular && <span style={styles.popular}>Popular</span>}
              <h3 style={styles.title}>{pkg.title}</h3>

              <div style={styles.inclusions}>
                <p><strong>Package Inclusion:</strong></p>
                {(openIndex === index ? pkg.highlights : pkg.highlights.slice(0, 2)).map((h, i) => (
                  <p key={i}>➤ {h}</p>
                ))}
              </div>

              <button 
                onClick={() => toggleAccordion(index)} 
                style={styles.readMore}
              >
                {openIndex === index ? 'Read Less ↑' : 'Read More ↓'}
              </button>

              <div style={styles.boxedInfo}>
                <p><FaClock style={{ marginRight: 5 }} />{pkg.duration}</p>
                <p><FaMapMarkerAlt style={{ marginRight: 5 }} />{pkg.locations}</p>
              </div>

              <div style={styles.buttons}>
                <a href="https://wa.me/917597700113"className='whatsappbtn'>
                  <FaWhatsapp /> WhatsApp Now
                </a>
                <a href="tel:7339700107"className='enq'>
                  <MdSend /> Enquire Now
                </a>
              </div>

              <p style={styles.formNote}>📩 To get full tour package details, kindly fill out the enquiry form.</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: { padding: '40px 20px', background: '#fff' },
  grid: { 
    display: 'flex', 
    gap: '30px', 
    flexWrap: 'wrap', 
    justifyContent: 'space-between' // ensures even spacing
  },
  
  card: { 
    backgroundColor: '#fff', 
    borderRadius: '15px', 
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)', 
    overflow: 'hidden', 
    flex: '1 1 calc(33.333% - 30px)', // 3 per row minus gap
    maxWidth: 'calc(33.333% - 30px)' 
  },
  image: { width: '100%', height: '200px', objectFit: 'cover' },
  content: { padding: '20px' },
  popular: { backgroundColor: '#00d084', color: '#fff', fontSize: '12px', padding: '4px 10px', borderRadius: '20px', display: 'inline-block', marginBottom: '10px' },
  title: { color: '#e60023', fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' },
  inclusions: { fontSize: '14px', marginBottom: '10px', color: '#555' },
  readMore: { background: 'none', border: 'none', color: '#e60023', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px', marginBottom: '15px' },
  boxedInfo: { border: '1px solid #ccc', padding: '12px', borderRadius: '10px', marginBottom: '15px', fontSize: '14px', backgroundColor: '#f9f9f9', color: '#333' },
  buttons: { display: 'flex', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' },
  button: { display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 15px', color: '#fff', textDecoration: 'none', borderRadius: '8px', fontWeight: 'bold', flex: '1 1 48%', justifyContent: 'center' },
  formNote: { fontSize: '12px', color: '#555', marginTop: '10px' },
  
};


export default Packages;
